// Single source of truth for the Cognito hosted-login redirect URL.
// Imported by both AuthProvider.tsx (initial auth) and api.tsx (401 re-auth),
// so the NP vs Prod value only has to be maintained in one place.
//
// Switch the exported COGNITO_LOGIN_URL between the NP and Prod constants below
// for the matching deployment (same as the commented pair in AuthProvider.tsx).

// PROD Deployment
export const COGNITO_LOGIN_URL_PROD =
    "https://campaignmanager.auth.us-west-2.amazoncognito.com/oauth2/authorize?response_type=token&identity_provider=Okta&client_id=6b7dqqf4t78r5oh6lfq25c71os&redirect_uri=https://campaign-manager.dish.com/&scope=email+openid";

// NONPROD Deployment
export const COGNITO_LOGIN_URL_NP =
    "https://campaignmanagernp.auth.us-west-2.amazoncognito.com/oauth2/authorize?response_type=token&identity_provider=Okta&client_id=6pgb9kfke516ta38mje3la2u08&redirect_uri=https://vcynnruzjn.us-west-2.awsapprunner.com/&scope=email+openid";

// Active login URL. Set to the Prod constant for prod builds.
export const COGNITO_LOGIN_URL = COGNITO_LOGIN_URL_PROD;
